module.exports = __webpack_public_path__ + "static/media/sliders-h.ddee8167.svg";